import { jsx, jsxs } from 'react/jsx-runtime';
import { useEffect, useRef } from 'react';
import Image from 'frontend-image';
import { ScriptPrint } from '@ads-placements-frontend/commons';
const VIEWABILITY_ENABLED = 'viewability-enabled';
const VIEWABILITY_BREAKING_CHANGES_VERSION = '1.0.0';
const isViewabilityLegacy = viewability => viewability && (viewability === null || viewability === void 0 ? void 0 : viewability.version) !== VIEWABILITY_BREAKING_CHANGES_VERSION;
const isViewabilityLoaded = viewability => viewability && (viewability === null || viewability === void 0 ? void 0 : viewability.getNonceToken()) !== '';
const useViewability = (ref, viewUrl, isPreview) => {
  const startViewabilitySession = () => {
    var _window$viewability;
    const session = (_window$viewability = window.viewability) === null || _window$viewability === void 0 ? void 0 : _window$viewability.addSession();
    session === null || session === void 0 || session.setMeliVaTrackUrl(viewUrl);
    session === null || session === void 0 || session.start(ref === null || ref === void 0 ? void 0 : ref.current);
  };
  useEffect(() => {
    if (isPreview || !viewUrl || !ref) {
      return () => null;
    }
    if (isViewabilityLegacy(window.viewability)) {
      var _window$viewability2;
      (_window$viewability2 = window.viewability) === null || _window$viewability2 === void 0 || _window$viewability2.addSession(ref.current, viewUrl);
      return () => null;
    }
    if (isViewabilityLoaded(window.viewability)) {
      startViewabilitySession();
      return () => null;
    }
    window.addEventListener(VIEWABILITY_ENABLED, startViewabilitySession);
    return () => {
      window.removeEventListener(VIEWABILITY_ENABLED, startViewabilitySession);
    };
  }, [ref, viewUrl, isPreview]);
};
const ThbDouble = _ref => {
  let {
    items,
    gapGrid,
    justifyContent,
    preloadImages,
    lazyloadImages
  } = _ref;
  const ref = useRef(null);
  if (!items || !items.length) {
    return null;
  }
  const renderLegalAndCtaText = (legal, cta) => {
    if (legal) {
      return jsx("div", {
        className: "thb-double-legal-container",
        children: jsx("span", {
          className: "thb-double-text-legal",
          children: legal
        })
      });
    }
    if (cta) {
      return jsx("div", {
        className: "thb-double-cta-container",
        children: jsx("span", {
          className: "thb-double-text-cta",
          children: cta
        })
      });
    }
    return null;
  };
  return jsx("div", {
    ref: ref,
    className: "thb-double-wrapper",
    "data-testid": "thb-double-container",
    style: {
      gap: gapGrid,
      justifyContent
    },
    children: items.length && items.map(item => {
      var _ref2;
      const {
        content: {
          images: {
            picture,
            primary_logo: primaryLogo,
            secondary_logo: secondaryLogo
          },
          texts: {
            cta,
            primary_title: primaryTitle,
            secondary_title: secondaryTitle,
            volanta,
            legal
          },
          colors: {
            card_background_color: cardBackgroundColor,
            card_text_color: cardTextColor
          },
          a11y: {
            context_banner: contextBanner
          }
        },
        event_tracking: {
          print: [{
            url: printUrl = ''
          } = {}],
          click: [{
            url: clickUrl = ''
          } = {}],
          view
        }
      } = item;
      const itemKey = "".concat(primaryTitle, "-").concat(secondaryTitle, "-").concat(picture || '');
      const viewUrl = view ? (_ref2 = [...view]) === null || _ref2 === void 0 || (_ref2 = _ref2.shift()) === null || _ref2 === void 0 ? void 0 : _ref2.url : null;
      useViewability(ref, viewUrl);
      return jsxs("a", {
        className: "thb-double-content-target",
        href: clickUrl || '#',
        "aria-label": contextBanner || '',
        children: [jsxs("div", {
          className: "thb-double-container",
          children: [jsx("div", {
            className: "thb-double-left-side",
            style: {
              color: cardTextColor,
              background: cardBackgroundColor
            },
            children: jsxs("div", {
              className: "thb-double-left-container",
              children: [primaryLogo || secondaryLogo ? jsxs("div", {
                className: "thb-double-left-img-container",
                children: [primaryLogo && jsx(Image, {
                  className: "thb-double-logo",
                  src: primaryLogo,
                  preload: preloadImages,
                  lazyload: lazyloadImages,
                  alt: primaryTitle,
                  "aria-hidden": "true"
                }), secondaryLogo && jsx(Image, {
                  className: "thb-double-logo",
                  src: secondaryLogo,
                  preload: preloadImages,
                  lazyload: lazyloadImages,
                  alt: primaryTitle,
                  "aria-hidden": "true"
                })]
              }) : null, jsxs("div", {
                className: "thb-double-texts-container",
                children: [volanta && jsx("span", {
                  className: "thb-double-text-volanta",
                  children: volanta
                }), jsxs("div", {
                  className: "thb-double-titles-container",
                  children: [jsx("h2", {
                    className: "thb-double-text",
                    children: primaryTitle
                  }), jsx("h2", {
                    className: "thb-double-text",
                    children: secondaryTitle
                  })]
                }), renderLegalAndCtaText(legal, cta)]
              })]
            })
          }), jsx("div", {
            className: "thb-double-right-side",
            children: jsx("div", {
              className: "thb-double-image-container",
              children: picture && jsx(Image, {
                className: "thb-double-picture",
                src: picture,
                preload: preloadImages,
                lazyload: lazyloadImages,
                alt: primaryTitle,
                "aria-hidden": "true"
              })
            })
          })]
        }), printUrl && jsx(ScriptPrint, {
          url: printUrl
        })]
      }, itemKey);
    })
  });
};
ThbDouble.defaultProps = {
  gapGrid: '16px',
  justifyContent: 'center',
  preloadImages: true,
  lazyloadImages: 'off'
};
export { ThbDouble };
